<template>
  <card class="card" title="Edit Zoom Profile">
    <div>
      <form @submit.prevent>
        <div class="row">

          <div class="col-md-6">

            <fg-input type="text"
                      label="Username"
                      placeholder="Username"
                      v-model="user.first_name">
            </fg-input>
          </div>
          <div class="col-md-6">
            <fg-input type="email"
                      label="Email"
                      placeholder="Email"
                      v-model="user.email">
            </fg-input>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <fg-input type="text"
                      label="First Name"
                      placeholder="First Name"
                      v-model="user.first_name">
            </fg-input>
          </div>
          <div class="col-md-6">
            <fg-input type="text"
                      label="Last Name"
                      placeholder="Last Name"
                      v-model="user.last_name">
            </fg-input>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <fg-input type="text"
                      label="Personal Meeting"
                      placeholder="Home Address"
                      v-model="user.personal_meeting_url">
            </fg-input>
          </div>
          <div class="col-md-6">
            <fg-input type="text"
                      label="Phone Number"
                      placeholder="Phone Number"
                      v-model="user.phone_number">
            </fg-input>
          </div>
        </div>
        <div class="text-center">
          <p-button type="info"
                    round
                    @click.native.prevent="updateProfile" disabled>
            Update Zoom Profile
          </p-button>
        </div>
        <div class="clearfix"></div>
      </form>
    </div>
  </card>
</template>
<script>
export default {
  props: ['user'],
  methods: {
    updateProfile() {
      alert("Your data: " + JSON.stringify(this.user));
    }
  }
};
</script>
<style>
</style>
